export default {
  created () {
    this.extandData = {}
  },
}
